module.exports = __webpack_public_path__ + "static/media/taffiethule36.90bd7778.jpg";